
<template>
  <div id="Studentdetails">
    <Header></Header>
    <Solid></Solid>
    <div class="leftpadding">
      <div class="toparea">
        <div class="crumbs">
          <Goback></Goback>
        </div>
      </div>
      <a-row>
        <a-col :md="{ span: 6 }" :xs="{ span: 24 }">
          <Cardtitle msg="基本信息"></Cardtitle>
          <Studentinfo :stuinfo="stuinfo"></Studentinfo>
        </a-col>
        <a-col :md="{ span: 6 }" :xs="{ span: 0 }"></a-col>
        <a-col :md="{ span: 6 }" :xs="{ span: 24 }">
          <Cardtitle msg="训练成绩"></Cardtitle>
          <Trainresult :stuinfo="stuinfo"></Trainresult>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <Cardtitle msg="考生照片"></Cardtitle>
          <div v-if="isshow" class="imglist">
            <img
              v-for="(item, index) in picturelist"
              :key="index"
              :src="item"
            />
          </div>
          <!-- <div  v-if="true" class="imglist">
            <img src="./../../assets/img_1.png" alt="">
            <img src="./../../assets/img_1.png" alt="">
            <img src="./../../assets/img_1.png" alt="">
            <img src="./../../assets/img_1.png" alt="">
            <img src="./../../assets/img_1.png" alt="">
            <img src="./../../assets/img_1.png" alt="">
          </div> -->
          <div v-else class="nohavepic">
            <!-- {{Boolean(stuinfo.picture_urls.length)}} -->
            <img src="./../../assets/nohave_pic.png" alt="" srcset="" /><br />
            <span>这个考生还没有照片</span>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Solid from "@/components/Solid/Solid";
import Goback from "@/components/Goback/Goback";
import Cardtitle from "@/components/Cardtitle/Cardtitle";
import Studentinfo from "@/components/Studentinfo/Studentinfo";
import Trainresult from "@/components/Trainresult/Trainresult";
import Axios from "@/Axios"
export default {
  name: "Studentdetails",
  components: {
    Header,
    Solid,
    Goback,
    Cardtitle,
    Studentinfo,
    Trainresult,
  },
  data() {
    return {
      stuinfo: {},
      isshow: false,
      picturelist: [],
    };
  },
  mounted() {
    this.stuinfo = this.$route.query;
    this.getpicture()
    this.getStuInfo()
  },
  methods: {
    getStuInfo() {
      Axios.get("/student/yhaStudent/qByDigital", {
        params: {
          digitalCode: this.$route.query.digital_id,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          this.stuinfo = {...this.stuinfo, ...records[0]}
        }
      });
    },
    getpicture() {
      Axios.get("/picture/yhaPicture/list", {
        params: {
          digitalCode: this.$route.query.digital_id,
          pageNo: 1,
          pageSize: 30,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          var piclist = [];
          records.map((item) => {
            piclist.push(window.network["domianURL"] + "/" + item.picUrl);
          });
          this.picturelist = piclist;
          this.isshow = this.picturelist.length
        }
      });
    },
  },
};
</script>
<style scoped>
.leftpadding {
  box-sizing: border-box;
  padding: 0 3vw;
}
.crumbs {
  display: flex;
  height: 8vh;
  border-bottom: 1px solid rosybrown;
  justify-content: flex-start;
  align-items: center;
}
.imglist {
  margin-top: 2vh;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.imglist img {
  width: 25vw;
  height: 13vw;
  margin-right: 2vw;
  border-radius: 5px;
}
.nohavepic {
  margin-top: 50px;
}
.nohavepic img {
  width: 200px;
  /* height: 200px; */
}
@media screen and (max-width: 768px) {
  .imglist {
    margin-bottom: 20vh;
  }
  .imglist img {
    width: 25vw;
    height: 15vh;
    margin-top: 3vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Studentdetails/Studentdetails.vue